import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled.div`
  display: flex;
  flex-flow: column wrap;
  width: 100%;
  background-color: var(--color-white);
  border-bottom: 1px solid var(--color-accent3);
`;
const Header = styled.div`
  padding: 2rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  p {
    margin: 0;
  }
  svg {
    padding-right: 2rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
      padding-right: 0;
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    padding: 1rem 0;
  }
`;
const Hidden = styled.div`
  display: flex;
  max-width: 100%;
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  visibility: hidden;
  transition: all 0.2s ease-in;

  div {
    padding-bottom: 2rem;
  }

  p {
    margin: 0;
    font-size: 0.9rem;
  }

  &.visible {
    opacity: 1;
    max-height: 100%;
    visibility: visible;
  }
`;
export function ExpandCollapse({ children }) {
  const [isOpen, setOpen] = React.useState(false);
  const child = React.Children.map(children, (child) => {
    return <div>{child}</div>;
  });
  return (
    <Wrapper>
      <Header onClick={() => setOpen(!isOpen)}>
        {child?.[0]?.props.children}
        <FontAwesomeIcon
          icon={isOpen ? faChevronUp : faChevronDown}
          size="1x"
        />
      </Header>
      <Hidden className={isOpen ? "visible" : ""}>
        {child?.[1]?.props.children}
      </Hidden>
    </Wrapper>
  );
}
ExpandCollapse.propTypes = {
  children: PropTypes.node,
};

ExpandCollapse.defaultProps = {
  children: undefined,
};
